import { render, staticRenderFns } from "./Scaffold.vue?vue&type=template&id=39fcdfd6&scoped=true&"
import script from "./Scaffold.vue?vue&type=script&lang=js&"
export * from "./Scaffold.vue?vue&type=script&lang=js&"
import style0 from "./Scaffold.vue?vue&type=style&index=0&id=39fcdfd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fcdfd6",
  null
  
)

export default component.exports